export default __webpack_public_path__ + "static/iris-006dd36487d3386068420d90852a03de.png";